import { createContext } from 'react'

/**
 * ¿El sidebar está colapsado? Lo provee el Layout, que es dueño de ese estado,
 * y lo lee `useDisposicion` para decidir columna o cajón con el ancho que el
 * sidebar ocupa de verdad (DEF-052): con el menú colapsado sobran 172 px y el
 * panel del caso no tiene por qué plegarse.
 *
 * `false` por defecto —expandido, el peor caso— para la pantalla que se monte
 * fuera del Layout.
 */
export const SidebarColapsado = createContext(false)
